/**
 * Shared window for admin trade-history / monthly trade-log views.
 * Desk request: pull live backlog history back through October 2025.
 */
export const ADMIN_TRADE_HISTORY_START = new Date(2025, 9, 1); // 1 Oct 2025 local

/** Firestore-friendly Timestamp-like Date bound (start of day). */
export const adminTradeHistoryStartDate = () => new Date(ADMIN_TRADE_HISTORY_START.getTime());

/**
 * Month picker options from ADMIN_TRADE_HISTORY_START through the current month
 * (newest first).
 */
export const buildAdminTradeMonthOptions = (now = new Date()) => {
  const opts = [];
  let cursor = new Date(now.getFullYear(), now.getMonth(), 1);
  const floor = new Date(
    ADMIN_TRADE_HISTORY_START.getFullYear(),
    ADMIN_TRADE_HISTORY_START.getMonth(),
    1,
  );

  while (cursor >= floor) {
    opts.push({
      key: `${cursor.getFullYear()}-${cursor.getMonth()}`,
      year: cursor.getFullYear(),
      month: cursor.getMonth(),
      label: cursor.toLocaleString('en-US', { month: 'long', year: 'numeric' }),
    });
    cursor = new Date(cursor.getFullYear(), cursor.getMonth() - 1, 1);
  }
  return opts;
};

/** Cap for collection-wide backlog listeners (admin Trade Logs). Firestore rejects limit() above 10000. */
export const ADMIN_TRADE_LOGS_QUERY_LIMIT = 10000;

/** Cap for per-client backlog listeners (admin Client Trade History). */
export const ADMIN_CLIENT_TRADES_QUERY_LIMIT = 10000;
